// Generated by purs version 0.13.0
"use strict";
var Affjax = require("../Affjax/index.js");
var Affjax_ResponseFormat = require("../Affjax.ResponseFormat/index.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Argonaut_Core = require("../Data.Argonaut.Core/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_HTTP_Method = require("../Data.HTTP.Method/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Show = require("../Data.Show/index.js");
var Effect_Aff = require("../Effect.Aff/index.js");
var Effect_Class_Console = require("../Effect.Class.Console/index.js");
var Foreign = require("../Foreign/index.js");
var Simple_JSON = require("../Simple.JSON/index.js");
var getJSON = function (dictReadForeign) {
    return function (url) {
        return Control_Bind.bind(Effect_Aff.bindAff)(Affjax.request({
            method: new Data_Either.Left(Data_HTTP_Method.GET.value),
            url: url,
            headers: Affjax.defaultRequest.headers,
            content: Affjax.defaultRequest.content,
            username: Affjax.defaultRequest.username,
            password: Affjax.defaultRequest.password,
            withCredentials: Affjax.defaultRequest.withCredentials,
            responseFormat: Affjax_ResponseFormat.json
        }))(function (v) {
            if (v.body instanceof Data_Either.Left) {
                return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Effect_Class_Console.log(Effect_Aff.monadEffectAff)("GET " + (url + ("response failed to decode: " + Affjax_ResponseFormat.printResponseFormatError(v.body.value0)))))(function () {
                    return Control_Applicative.pure(Effect_Aff.applicativeAff)(Data_Maybe.Nothing.value);
                });
            };
            if (v.body instanceof Data_Either.Right) {
                var v1 = Simple_JSON.readJSON(dictReadForeign)(Data_Argonaut_Core.stringify(v.body.value0));
                if (v1 instanceof Data_Either.Right) {
                    return Control_Applicative.pure(Effect_Aff.applicativeAff)(new Data_Maybe.Just(v1.value0));
                };
                if (v1 instanceof Data_Either.Left) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Effect_Class_Console.log(Effect_Aff.monadEffectAff)(Data_Show.show(Data_List_Types.showNonEmptyList(Foreign.showForeignError))(v1.value0)))(function () {
                        return Control_Applicative.pure(Effect_Aff.applicativeAff)(Data_Maybe.Nothing.value);
                    });
                };
                throw new Error("Failed pattern match at Chip.Lib.JSON (line 35, column 9 - line 39, column 25): " + [ v1.constructor.name ]);
            };
            throw new Error("Failed pattern match at Chip.Lib.JSON (line 25, column 3 - line 39, column 25): " + [ v.body.constructor.name ]);
        });
    };
};
module.exports = {
    getJSON: getJSON
};
